import { z } from 'zod';
/**
 * Token de desenvolvimento: `dev.` seguido do JSON da pessoa em base64url.
 * Não tem assinatura de propósito, para ninguém confundi-lo com segurança. O
 * backend só o aceita com `AUTH_MODE=dev`, que o boot recusa em produção.
 */
export const DEV_TOKEN_PREFIX = 'dev.';
export const devIdentitySchema = z.strictObject({
    /**
     * E-mail ou UPN, como o Teams informa. Não é `z.email()`: o UPN de um
     * convidado (`pessoa_dominio#EXT#@tenant.onmicrosoft.com`) não passaria.
     */
    email: z
        .string()
        .trim()
        .regex(/^[^@\s]+@[^@\s]+$/, 'E-mail inválido'),
    name: z.string().trim().min(1),
});
//# sourceMappingURL=dev-token.contract.js.map